import * as React from 'react';
import styles from './overlay.scss';

export interface WithOverlayProps {
  displayOverlay: boolean;
  overlayText: string;
  children?: React.ReactNode;
}

export class OverlayComponent extends React.PureComponent<WithOverlayProps, any> {
  private keyEvent = (e: React.SyntheticEvent<any>) => {
    if (this.props.displayOverlay) {
      e.preventDefault();
    }
  };

  public render() {
    return (<div onKeyDown={this.keyEvent}>
      {this.props.displayOverlay && <div className={styles.overlay}>
        <div className={`${styles.iconAsBg} ${styles.spinLoader}`} />
        <h1>{this.props.overlayText}</h1>
        <div className={styles.overlayBg} />
      </div>}
      {this.props.children}
    </div>);
  }
}
